interface AccountContactFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export default function AccountContactFilter({ value, onChange }: AccountContactFilterProps) {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="employmentFilter" className="text-sm font-medium text-brand-text-primary">
        Filter:
      </label>
      <select
        id="employmentFilter"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-sm border border-brand-border-input rounded px-3 py-1.5 bg-white text-brand-text-primary focus:outline-none focus:ring-2 focus:ring-brand-primary"
      >
        <option value="all">All Contacts</option>
        <option value="employed">Employed</option>
        <option value="notemployed">Not Employed</option>
      </select>
    </div>
  );
}
